const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.requestUserMeta.hideModal()
  }
}

export default OnEscape
